<template>
  <div>
    <v-btn
      tile
      theme="dark"
      color="pink"
      class="font-weight-bold"
      :loading="isSearching"
      :disabled="isSearching"
      @click="$emit('search')"
    >
      検索
    </v-btn>
    <v-btn
      tile
      theme="dark"
      variant="outlined"
      color="pink"
      class="font-weight-bold"
      @click="$emit('reset')"
    >
      リセット
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "DaytimeAdviceSearchActionButtons",
  props: {
    isSearching: {
      type: Boolean,
      required: true
    }
  },
  emits: ["search", "reset"]
};
</script>
